import { SovosBox, SovosFileUpload } from "mosaic-react";
import { SovosLinearProgress } from "mosaic-react";
import { forwardRef } from "react";

const UploadFileForm = ({ filesList, showLinearProgress }, ref) => {
    return (
        <SovosBox>
            <SovosBox>
                {showLinearProgress?.current && <SovosLinearProgress />}
                <SovosFileUpload
                    sx={{ width: "100%" }}
                    buttonLabel={"Browse"}
                    acceptedTypes={[
                        "csv",
                        "text/xml",
                        "application/zip",
                        "application/gzip",
                        "application/x-gzip",
                        "text/plain",
                        "application/xml",
                        "application/x-zip-compressed",
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "text/txt"
                    ]}
                    onFilesSelected={(filesToUpload) => {
                        filesList.current.push(...filesToUpload);
                    }}
                    onFileClick={() => { }}
                />
            </SovosBox>
        </SovosBox>
    );
};

const UploadFileFormFormRef = forwardRef(UploadFileForm);

export default UploadFileFormFormRef;
